/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RoofTrimStyle {
    Unknown = 0,
    Aluminum = 1,
    BlackAluminum = 2,
    ZincFlat = 3,
}
